import {merge} from 'lodash-es';
import {BaseOctopusConfig} from '../../../../base.octopus-config';
import {defaultApiURL} from '../../../../src/app/settings/cycle-2-et-3-tne-canope';

const overrideConfig = {
    configuration: {
        http: {
            apiUrl: defaultApiURL,
        }
    }
}

export const Cycle2Et3TneCanopeOctopusConfig = merge({}, BaseOctopusConfig, overrideConfig);